import { InlineElements } from './InlineElements'

export const OrderedListBlock = ({ items }) => (
    <ol style={{ margin: '0px' }}>
        {items.map((item, index) => (
            <li key={index} value={item.number}>
                <InlineElements contents={item.value} />
            </li>
        ))}
    </ol>
)
